import React, {
  FC,
  ReactNode,
  useState,
  createContext,
  useContext,
} from 'react';
import { GetVehicleByExactVinResponseType } from 'QuoteApp/components/VehiclesList/VehicleSelection';

type VehicleMultiselectContextType = {
  multipleVehicleData: GetVehicleByExactVinResponseType[];
  setMultipleVehicleData: (data: GetVehicleByExactVinResponseType[]) => void;
  isEditingMultiple: boolean;
  setIsEditingMultiple: (isEditing: boolean) => void;
};

const VehicleMultiselectContext = createContext<VehicleMultiselectContextType>({
  multipleVehicleData: [],
  setMultipleVehicleData: () => {},
  isEditingMultiple: false,
  setIsEditingMultiple: () => {},
});

export const VehicleMultiselectProvider: FC<{
  children: (context: VehicleMultiselectContextType) => ReactNode;
}> = ({ children }) => {
  const [multipleVehicleData, setMultipleVehicleData] = useState<
    GetVehicleByExactVinResponseType[]
  >([]);
  const [isEditingMultiple, setIsEditingMultiple] = useState<boolean>(false);

  return (
    <VehicleMultiselectContext.Provider
      value={{
        multipleVehicleData,
        setMultipleVehicleData,
        isEditingMultiple,
        setIsEditingMultiple,
      }}
    >
      {children({
        multipleVehicleData,
        setMultipleVehicleData,
        isEditingMultiple,
        setIsEditingMultiple,
      })}
    </VehicleMultiselectContext.Provider>
  );
};

export const useVehicleMultiselect = () => {
  const {
    multipleVehicleData,
    setMultipleVehicleData,
    isEditingMultiple,
    setIsEditingMultiple,
  } = useContext(VehicleMultiselectContext);

  return {
    multipleVehicleData,
    setMultipleVehicleData,
    isEditingMultiple,
    setIsEditingMultiple,
  };
};
